import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Stethoscope } from 'lucide-react';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[70vh] grid place-items-center">
        <span className="grid place-items-center w-14 h-14 rounded-2xl text-white animate-pulse" style={{ background: 'linear-gradient(135deg,#0f766e,#0b3b3a)' }}>
          <Stethoscope size={26} />
        </span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}
